<template>
  <div class="row bg-blue repair-actions">
    <div class="col-auto">
      <button type="button" class="btn btn-size-s" @click="emitCommand('DisplayWO')">
        {{L10n('display-wo')}}
      </button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-size-s" @click="emitCommand('DisplayCustomer')">
        {{L10n('display-customer-po-followup')}}
      </button>
    </div>
    <div class="col-auto">
      <logo-button
        class="logo-btn"
        :get-pdf-content="getPdfContent"
        @click="emitCommand('DownloadTDReport', $event)"
      >
        {{L10n('download-td-report')}}
      </logo-button>
    </div>
    <div class="col-auto">
      <logo-button
        class="logo-btn"
        :get-pdf-content="getPdfContent"
        @click="emitCommand('EmailTD', $event)"
      >
        {{L10n('email-td')}}
      </logo-button>
    </div>
    <div class="col-auto">
      <logo-button
        class="logo-btn"
        :get-pdf-content="getPdfContent"
        @click="emitCommand('EmailTDReport', $event)"
      >
        {{L10n('email-td-report')}}
      </logo-button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-size-s" @click="emitCommand('UpdatePriceWO')">{{L10n('update-prices-wo')}}</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-size-s" @click="emitCommand('UpdatePricePO')">{{L10n('update-prices-po')}}</button>
    </div>
  </div>
</template>

<script>
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'UserActions',
  props: {
    rfq3ID: { type: String, required: true }
  },
  components: {
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton')
  },
  methods: {
    emitCommand (command, ...arg) {
      this.$emit(`on${command}`, ...arg)
    },
    getPdfContent () {
      return ServicePdf.generateTdContent({ id: this.rfq3ID, translate: this.L10n })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .btn, .logo-btn{
    margin 1rem 0
  }
  .repair-actions{
    padding: 1.5rem;
    margin: -2rem -2.5rem 0 -2.5rem;
  }
</style>
